import Vue from 'vue'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueJsonp from 'vue-jsonp'

import App from './App.vue'

import './css/base.css'
import router from './router'
import vueLazyImg from './js/lazy-img.js'
import store from './store'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(vueLazyImg);
// Vue.use(VueJsonp)
Vue.use(VueAxios, axios);
Vue.use(VueJsonp, 5000);

// router.beforeEach((from, to, next) => {
//     if (to.meta.requireAuth) { // 判断跳转的路由是否需要登录
//         var name = sessionStorage.getItem("name");
//         if (name) { // vuex.state判断token是否存在
//             next() // 已登录
//         } else {
//             next({
//                 path: '/',
//                 ///query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
//             })
//         }
//     } else {
//         next()
//     }
// })

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')